import store from "@/store";

export const SYNC_PROFILES = {
	COPILOT: "copilot",
	USER: "user",
	WEHOST: "wehost",
};

/**
 * @param {'copilot'|'user'|'wehost'} profile
 * @param {{ venueId?: number|string, userId?: string, deviceToken?: string }} context
 */
export function buildClientId(profile, context = {}) {
	if (profile === SYNC_PROFILES.COPILOT) {
		return `COPILOT_${context.venueId}`;
	}

	if (profile === SYNC_PROFILES.WEHOST) {
		return `WEHOST_${context.venueId}`;
	}

	return String(context.userId ?? "");
}

/**
 * @param {'copilot'|'user'|'wehost'} profile
 * @param {{ venueId?: number|string, userId?: string, reservationId?: number|string, deviceToken?: string }} context
 */
export function buildMercureSubscribePayload(profile, context = {}) {
	if (profile === SYNC_PROFILES.COPILOT) {
		return {
			profile: "copilot",
			venueId: context.venueId,
			deviceToken: context.deviceToken,
		};
	}

	if (profile === SYNC_PROFILES.WEHOST) {
		return {
			profile: "wehost",
			venueId: context.venueId,
		};
	}

	return {
		profile: "user",
		reservationId: context.reservationId,
		venueId: context.venueId,
	};
}

/**
 * @param {'copilot'|'user'|'wehost'} profile
 * @param {{ venueId?: number|string, userId?: string, reservationId?: number|string, deviceToken?: string }} context
 * @returns {string[]}
 */
export function buildSseTopics(profile, context = {}) {
	const base = store.state.config.sseTopicBase;
	if (!base) {
		return [];
	}

	if (profile === SYNC_PROFILES.COPILOT) {
		const topics = [`${base}/copilot/${context.venueId}`];
		if (context.deviceToken) {
			topics.push(`${base}/device/${context.deviceToken}`);
		}
		return topics;
	}

	if (profile === SYNC_PROFILES.WEHOST) {
		return [`${base}/wehost/${context.venueId}`];
	}

	const topics = [`${base}/user/${context.userId}`];
	if (context.reservationId) {
		topics.push(`${base}/reservation/${context.reservationId}`);
	}
	if (context.venueId) {
		topics.push(`${base}/venue/${context.venueId}`);
	}

	return topics;
}

